import { render, staticRenderFns } from "./examDetail.vue?vue&type=template&id=115ab8b8&scoped=true&"
import script from "./examDetail.vue?vue&type=script&lang=js&"
export * from "./examDetail.vue?vue&type=script&lang=js&"
import style0 from "./examDetail.vue?vue&type=style&index=0&id=115ab8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ab8b8",
  null
  
)

export default component.exports